import React from 'react';
import { slideWrapper } from '../components/slide';
import { Content } from '../components/content';
import styled from 'styled-components';
import { RoundLetters, RoundType } from '@disco/data';
import { PuzzleItems } from '../components/puzzle-items';

const TextImage = styled.img<any>`
  position: absolute;
  left: 2%;
  top: -400px;
  width: 450px;
  transition: top 1s;
`;

export const HypatiaPuzzle1Counting = slideWrapper(
  ({ step, getImg, countingResults, countingResultsLoading }) => {
    const { answers } = step;

    return (
      <>
        <TextImage src={getImg('text1')} />
        <Content xNotCenter yNotCenter left={1} bottom={1}>
          <img height={200} src={getImg('things1')} />
        </Content>
        <PuzzleItems {...{ countingResults, countingResultsLoading, getImg, answers, letters: RoundLetters[3] }} />
      </>
    );
  },
  { countAnswersTour: RoundType.Hypatia }
);
